<template>
    <div v-if="loaded">
        <form class="signup_form" @submit.prevent="$emit('next', formData)" v-if="loaded">
            <ul>
                <div class="part">
                    <li class="title">
                        <label>דירוגים מקצועיים (אופציונאלי)</label>
                        <span>ניתן לבחור יותר מאחד.עבור כל אחד, יש להזין קישור שמוביל לעמוד עם הדירוג</span>
                    </li>
                    <li>
                        <label>BDI דירוג</label>
                        <input type="text" v-model="formData.bdi_rating_link" placeholder="קישור לעמוד עם הדירוג" >
                    </li>
                    <li>
                        <label>D&B דירוג</label>
                        <input type="text" v-model="formData.bd_rating_link" placeholder="קישור לעמוד עם הדירוג" >
                    </li>
                    <li>
                        <label>דירוג מדד התחדשות עירונית</label>
                        <input type="text" v-model="formData.urban_renewal_rating_link" placeholder="קישור לעמוד עם הדירוג" >
                    </li>
                </div>
                <div class="part">
                    <li class="title">
                        <label>דו”ח BDI או DUNS</label>
                        <span>יש למלא לפחות דוח אחד. צוות המכרז השקוף יבדוק את תקינות הדוח לאחר תהליך ההצטרפות</span>
                    </li>
                    <li>
                        <label>דו”ח BDI</label>
                        <input type="text" onfocus="(this.type='date')" onblur="(this.type='text')" v-model="formData.bdi_report_date" placeholder="בחירת תאריך" >
                        <!-- <a class="btn_b">
                            <span>העלאת קובץ</span>
                            <span class="upload_icon icon"></span>
                        </a> -->
                        <GalleryInput :max="1" v-model="formData.bdi_report_file" @onUpload="(data) => { formData.bdi_report_file = data.id }" />
                        <span class="helper_text">יש להעלות קובץ מסוג PDF המאשר את סוג הסיווג</span>
                    </li>
                    <li>
                        <label>דו”ח DUNS</label>
                        <input type="text" onfocus="(this.type='date')" onblur="(this.type='text')" v-model="formData.duns_report_date" placeholder="בחירת תאריך" >
                        <!-- <a class="btn_b">
                            <span>העלאת קובץ</span>
                            <span class="upload_icon icon"></span>
                        </a> -->
                        <GalleryInput :max="1"  v-model="formData.duns_report_file" @onUpload="(data) => { formData.duns_report_file = data.id }" />
                        <span class="helper_text">יש להעלות קובץ מסוג PDF המאשר את סוג הסיווג</span>
                    </li>
                </div>
                <div class="part">
                    <li class="title">
                        <label>אישור מורשי חתימה בשם התאגיד</label>
                        <span>חתום ע"י עורך דין או רואה חשבון</span>
                    </li>
                    <div class="gray_area">
                    <li>
                        <label>שם מלא</label>
                        <input type="text" v-model="formData.approval_authorized_signatories_full_name" >
                    </li>
                    <li>
                        <label>תפקיד</label>
                        <input type="text" v-model="formData.approval_authorized_signatories_job" >
                    </li>
                    <li>
                        <label>אישור</label>
                        <!-- <a class="btn_b">
                            <span>העלאת קובץ</span>
                            <span class="upload_icon icon"></span>
                        </a> -->
                        <GalleryInput v-model="formData.approval_authorized_signatories_file" :max="1" @onUpload="(data) => { formData.approval_authorized_signatories_file = data.id }" />
                        <span class="helper_text">מומלץ להעלות קובץ בגודל מינימלי של 300X200 פיקסלים</span>
                    </li>
                    
                    </div>
                </div>
                <div class="part">
                    <li class="title">
                        <label>אישור מורשי חתימה בשם התאגיד</label>
                        <span>חתום ע"י עורך דין או רואה חשבון</span>
                    </li>
                    <li>
                        <label>בנקים לליווי פיננסי</label>
                        <!-- <multiselect
                            v-model="formData.banks_financial_support"
                            :options="banks_list"
                            :closeOnSelect="false"
                            :multiple="true"
                            :searchable="false"
                            placeholder="בחרו"
                            selectLabel="לחצו לבחירה"
                            deselectLabel="לחצו להסרה"
                            label="name"
                            track-by="id"
                        /> -->
                        <wzMultiSelect v-model="formData.banks_financial_support" :settings="{ width: '100%', val: 'name', key: 'id', theme: 'light'}" :options="$store.banks_financial_support" />
                    </li>
                    <li>
                        <label>חברות ביטוח</label>
                        <!-- <multiselect
                            v-model="formData.insurance_companies"
                            :options="insurance_list"
                            :closeOnSelect="false"
                            :multiple="true"
                            :searchable="false"
                            placeholder="בחרו"
                            selectLabel="לחצו לבחירה"
                            deselectLabel="לחצו להסרה"
                            label="name"
                            track-by="id"
                        /> -->
                        <wzMultiSelect v-model="formData.insurance_companies" :settings="{ width: '100%', val: 'name', key: 'id', theme: 'light'}" :options="$store.insurance_companies" />
                    </li>
                    <li>
                        <label>חברות מימון</label>
                        <!-- <multiselect
                            v-model="formData.financing_companies"
                            :options="financing_list"
                            :closeOnSelect="false"
                            :multiple="true"
                            :searchable="false"
                            placeholder="בחרו"
                            selectLabel="לחצו לבחירה"
                            deselectLabel="לחצו להסרה"
                            label="name"
                            track-by="id"
                        /> -->
                        <wzMultiSelect v-model="formData.financing_companies" :settings="{ width: '100%', val: 'name', key: 'id', theme: 'light'}" :options="$store.financing_companies" />
                    </li>
                </div>
                <input  v-if="state != 'edit'" type="submit" class="btn" value="סיום ושליחת פרטים">
            </ul>
        </form>
    </div>
</template>

<script>
import GalleryInput from '../GalleryInput.vue';
// import Multiselect from 'vue-multiselect'
import WzMultiSelect from '../wzMultiSelect.vue';

export default {
    props: ["updatedData", "state"],
    components: {GalleryInput , WzMultiSelect},
    data() {
        return {
            loaded: false,
            formData: {
                bdi_rating_link: '',
                bd_rating_link: '',
                urban_renewal_rating_link: '',
                bdi_report_date: '',
                bdi_report_file: '',
                duns_report_date: '',
                duns_report_file: '',
                approval_authorized_signatories_full_name: '',
                approval_authorized_signatories_job: '',
                approval_authorized_signatories_file: '',
                banks_financial_support: [],
                insurance_companies: [],
                financing_companies: [],
                step: 4
            }
        }
    },
    mounted() {
        if (this.updatedData) {
            for (const key in this.formData) {
                if (this.updatedData[key]) this.formData[key] = this.updatedData[key];
            }
            if (this.formData.bdi_report_date === '0000-00-00') {
                this.formData.bdi_report_date = ''
            }
            if (this.formData.duns_report_date === '0000-00-00') {
                this.formData.duns_report_date = ''
            }
            this.loaded = true;
        }

    },
    watch: {
        formData: {
            handler: function (val) {
                this.$emit('update', val)
            },
            deep: true
        }
    }
}
</script>

<style>

</style>